module.exports = __webpack_public_path__ + "static/media/ic_calendar_question.d78392c4.svg";